import { createSlice } from '@reduxjs/toolkit';

import { loadMyClients } from './my-clients.middleware';
import { logout } from '../auth/auth-middleware';
import { Client } from 'api';

type MyClientsState = {
    list: Client[];
    currentClient: Client | null;
    error: string | null;
    isLoading: boolean;
};

const initialState: MyClientsState = {
    list: [],
    currentClient: null,
    error: null,
    isLoading: false,
};

export const myClientsSlice = createSlice({
    name: 'app/my-clients',
    initialState,
    reducers: {
        setCurrentClient: (
            state,
            action: { type: string; payload: { clientID: string | null } }
        ) => {
            if (action.payload.clientID === null) {
                state.currentClient = null;
                return;
            }

            const targetClient = state.list.find(
                (client) => client.id === Number(action.payload.clientID)
            );
            if (targetClient) {
                state.currentClient = targetClient;
            } else state.currentClient = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadMyClients.fulfilled, (state, action) => {
                state.list = action.payload;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(loadMyClients.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadMyClients.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.list = [];
                state.error = null;
                state.isLoading = false;
            });
    },
});

export const { setCurrentClient } = myClientsSlice.actions;
export default myClientsSlice.reducer;
